import React from 'react';
import Grid from '@mui/material/Grid';
import { CrossFade } from '../../../base/CrossFade';
import {
  LOADING_GRACE_MS,
  LOADING_MIN_DISPLAY_MS,
} from '../../../../hooks/useSmartLoading';
import { useDetailsViewContext } from '../DetailsViewContext';

import {
  ResourceHeader,
  ResourceImage,
  ProductCard,
  ResourceCard,
  ContactCard,
  CalendarSection,
} from '../components';
import { ResourceImageSkeleton } from '../components/ResourceImage';
import { ProductCardSkeleton } from '../components/ProductCard';
import { ResourceCardSkeleton } from '../components/ResourceCard';
import { ResourceHeaderSkeleton } from '../components/ResourceHeader';

/**
 * Mobile layout - stacks all components vertically
 * Order: Header -> Image -> Product -> Resource -> Contact -> Calendar
 */
export default function MobileLayout() {
  const { syncedLoading, showContactData, publicData, height } =
    useDetailsViewContext();

  return (
    <Grid id="mobile-layout" container columnSpacing={1} rowSpacing={1}>
      <Grid
        container
        item
        xs={12}
        sx={{
          mb: 2,
        }}
      >
        <CrossFade
          showSkeleton={syncedLoading}
          graceMs={LOADING_GRACE_MS}
          minDisplayMs={LOADING_MIN_DISPLAY_MS}
          skeleton={<LoadingSkeleton />}
        >
          <Grid container rowSpacing={1}>
            {/* Resource Image */}
            {publicData?.resource?.imgUrl && (
              <Grid item xs={12}>
                <ResourceImage
                  imgUrl={publicData.resource.imgUrl}
                  height={height}
                />
              </Grid>
            )}

            {/* Resource Header */}
            <Grid item xs={12}>
              <ResourceHeader />
            </Grid>

            {/* Resource Description */}
            {(publicData?.resource?.description ||
              publicData?.resource?.url) && (
              <Grid item xs={12}>
                <ResourceCard forceCollapsed={true} />
              </Grid>
            )}

            {/* Product Card */}
            <Grid item xs={12}>
              <ProductCard forceCollapsed={true} />
            </Grid>
          </Grid>
        </CrossFade>
      </Grid>
      {/* Calendar Section */}
      <Grid
        item
        xs={12}
        sx={{
          borderBottom: '1px solid',
          borderColor: 'grey.300',
        }}
      >
        <CalendarSection />
      </Grid>
      {/* Contact Information */}
      {showContactData && (
        <Grid
          item
          xs={12}
          sx={{
            mt: 1,
          }}
        >
          <ContactCard contact={publicData.contact} />
        </Grid>
      )}
    </Grid>
  );
}

/**
 * Loading skeleton
 */
function LoadingSkeleton() {
  return (
    <Grid container rowSpacing={1}>
      {/* Image skeleton */}
      <Grid item xs={12}>
        <ResourceImageSkeleton />
      </Grid>

      {/* Header skeleton */}
      <Grid item xs={12}>
        <ResourceHeaderSkeleton />
      </Grid>

      {/* Resource description skeleton */}
      <Grid item xs={12}>
        <ResourceCardSkeleton />
      </Grid>

      {/* Product card skeleton */}
      <Grid item xs={12}>
        <ProductCardSkeleton />
      </Grid>
    </Grid>
  );
}
